import { render, staticRenderFns } from "./DayWorkDetailsTabIO.vue?vue&type=template&id=44febcb6&"
import script from "./DayWorkDetailsTabIO.vue?vue&type=script&lang=js&"
export * from "./DayWorkDetailsTabIO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports